<template>
    <div class="explanation-container">
        <div class="full-width">
            <div class="shift-summary-card">
                <div class="d-flex align-center justify-center flex-wrap gap-2 mb-2">
                    <h4 class="text-h6 primary--text">
                        Open Shift Notification
                    </h4>
                </div>
                <p class="mb-1"><strong>Location:</strong> {{ shift_data.location }}</p>
                <p class="mb-1"><strong>Date:</strong> {{ shift_data.date }}</p>
                <p class="mb-0"><strong>Time:</strong> {{ shift_data.start_time }} - {{ shift_data.end_time }}</p>
            </div>
        </div>

        <section>
            <h3 class="text-h5 text-left mb-3">Here's what's happening ...</h3>
            <ul class="explanation-points">
                <li
                    class="explanation-point"
                    v-for="(point, idx) in explanation_points"
                    :key="idx"
                >
                    <v-icon
                        color="primary"
                        size="28"
                        class="point-icon"
                        aria-hidden="true"
                    >
                        mdi-chevron-right
                    </v-icon>
                    <p class="point-text" v-html="point"></p>
                </li>
            </ul>
        </section>
    </div>
</template>

<script>
export default {
    name: 'ExplainerInitialMessage',

    props: {
        shift_data: {
            type: Object,
            required: true
        },
        shift_status: {
            type: String,
            required: true
        }
    },

    computed: {
        explanation_points() {
            return [
                `Caring Hands Home Care, a home care agency, has an open shift that needs coverage for tomorrow`,
                `Using RedChirp, the agency sends a bulk SMS to all qualified caregivers with a link to view the shift details and claim it`,
                `Jamie, a caregiver, receives the SMS on her phone and clicks the link to view the shift details on the landing page`
            ];
        }
    }
}
</script>

<style lang="scss" scoped>
.explanation-container {
    display: flex;
    flex-direction: column;
    justify-content: center;
    gap: 2rem;
    align-items: center;
    padding: 2rem;

    @media (max-width: 900px) {
        padding: .5rem 0;
    }

    .shift-summary-card {
        background: #f0f7ff;
        border: 1px solid #d0e4f7;
        border-radius: calc(var(--border-radius-default) * 3);
        padding: 1.5rem;
        text-align: center;
    }
}
</style>
